module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tr-c3d773f3ebbea061e963baad5606508a.svg";